const white = '#fff';
const greyLightest = '#f4f4f4';
const greyLight = '#b4b4b4';
const greyMedium = '#888';
const greyMediumText = '#9b9b9b';
const greyDark = '#636363';
const greyDarkest = '#464646';
const qmBlue = '#4B6ED8';
const qmBlueLight = '#3398E6';
const qmGreen = '#009A52';
const qmBabyGreen = '#26B881';
const qmDisabledGreen = '#b2e1cb';
const qmRed = '#ea3e3e';

const borderRadius = 4;
const borderColor = '#d9d9d9';

const gutter = 16;
const oneHalfGutter = gutter * 1.5;
const halfGutter = gutter / 2;
const quarterGutter = gutter / 4;
const doubleGutter = gutter * 2;
const tripleGutter = gutter * 3;
const quadGutter = gutter * 4;

export default {
  white,
  greyLightest,
  greyLight,
  greyMedium,
  greyMediumText,
  greyDark,
  greyDarkest,
  qmBlue,
  qmBlueLight,
  qmGreen,
  qmBabyGreen,
  qmDisabledGreen,
  qmRed,

  borderRadius,
  borderColor,

  gutter,
  quarterGutter,
  oneHalfGutter,
  halfGutter,
  doubleGutter,
  tripleGutter,
  quadGutter,
};
